export default "__VITE_ASSET__CMu0o9Ae__"